// 颜色多选
function initBadge(seller_collection) {
  console.log(seller_collection);
  let isLoadEnd = 0;
  document.querySelectorAll(".card__content").forEach((item) => {
    item.querySelector(".card__badge").innerHTML = "";
  });
  seller_collection.forEach((item) => {
    //更新徽章
    let badge = updateBadge(item);
    console.log("badge:" + badge);
    let imgSrc = getBadgeIcon(badge);
    if (!imgSrc) return;
    let img = `<img src="${imgSrc}" style="width: 60px;margin-top:-20px;">`;
    console.log(img);
    if (!isLoadEnd) {
      var index = setTimeout(function () {
        if (
          document.querySelector("a[href='/products/" + item["handle"] + "']")
        ) {
          isLoadEnd = 1;
          clearTimeout(index);
          console.log("return");
        } else {
          console.log("continue");
        }
      }, 1000);
    }
    if (document.querySelector("a[href='/products/" + item["handle"] + "']"))
      document
        .querySelector("a[href='/products/" + item["handle"] + "']")
        .closest(".card__content")
        .querySelector(".card__badge").innerHTML = img;
  });
}

function updateBadge(item) {
  tags = item["tags"].filter((v) => {
    return v.indexOf("badge_") != -1;
  });
  let badge = tags.length >= 1 ? tags[0] : "";
  return badge ? badge.replace("badge_", "").replace(" - GONA", "") : "";
}

//FLASH SALE Microscopic Hand-Painted Enamel
function getBadgeIcon(badge) {
  let width = 75;
  let config = {
    "BEST SELLER": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/24993e49286824a215cf1344c424cdef_${width}x.png?v=1681872077`,
    "AVAILABLE IN 12 COLORS": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/12_3d37fe93-83c7-4ddc-85da-477aa0a7b989_${width}x.png?v=1681873318`,
    "HANDMADE": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/1e914964e901dc727bdb62f0a285193d_${width}x.png?v=1681872077`,
    "LIMITED EDITION": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/1b33aa81e08397cdd5a7acdf4a0abdd6_${width}x.png?v=1681872077`,
    "Microscopic Hand-Painted Enamel": `https://cdn.shopify.com/s/files/1/0549/2051/1688/files/Microscopic_Hand-Painted_Enamel_${width}x.png?v=1681883190`,
    "NEW ARRIVAL": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/5b5b0bae4214c877cc78248bdd149ba6_${width}x.png?v=1681872077`,
    "PREMIUM": `https://cdn.shopify.com/s/files/1/0549/2051/1688/files/PREMIUM_${width}x.png?v=1681883190`,
    "FLASH SALE": `https://cdn.shopify.com/s/files/1/0549/2051/1688/files/FLASH_${width}x.png?v=1681883190`,
    "ROSE GOLD": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/18K_${width}x.png?v=1681872077`,
    "SELF LOVE": `https://cdn.shopify.com/s/files/1/0549/2051/1688/files/SELF_LOVE_${width}x.png?v=1681883190`,
    "TRENDING COLOR": `https://cdn.shopifycdn.net/s/files/1/0549/2051/1688/files/96a4dfdb286577e600cfb589137d0c80_${width}x.png?v=1681872077`,
  };
  return config[`${badge}`];
}

function initSwitchColour(seller_collection) {
  // document.querySelectorAll(".card-information a").forEach((item)=>{
  //   let href = item.getAttribute("href");
  //   item.removeAttribute("href");
  //   item.setAttribute("data-href",href);
  // });
  let handles = [];
  let sku_number = "";
  seller_collection.forEach((item) => {
    if (handles.includes(item["handle"])) return;
    handles.push(item["handle"]);
    sku_number = item["handle"].match(/\d+(\.\d+)?/g)[0];
    console.log(sku_number);
    let url = `https://searchserverapi.com/getresults?api_key=1J5r3X3Z6u&q=${sku_number}&sortBy=relevance&sortOrder=desc&startIndex=0&maxResults=15&items=true&pages=true&categories=true&suggestions=true&queryCorrection=true&suggestionsMaxResults=3&pageStartIndex=0&pagesMaxResults=20&categoryStartIndex=0&categoriesMaxResults=20&facets=true&facetsShowUnavailableOptions=false&recentlyViewedProducts=7898991886578%2C6770676105416%2C7898986709234%2C7888716595442%2C7884610601202%2C7902067327218%2C7884610502898&ResultsTitleStrings=2&ResultsDescriptionStrings=2&timeZoneName=Asia%2FShanghai&output=jsonp&_=1681619285382`;
    fetch(url).then((data) => {return data.json();}).then((data) => {
        console.log(data);
        let html = "";
        let colours = [];
        if (data["items"].length <= 1) {
          try{
             document.querySelector("div[data-id='" + item["id"] + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="none";
             return;
          }catch(e){
            
          }
        }
        let colour_name_key = "";
        data["items"].forEach((value) => {
          console.log("options:");
          console.log(value["shopify_variants"][0]["options"]);
          colour_name_key = Object.keys(value["shopify_variants"][0]["options"]).filter((key)=>{return ["Stone Color","Enamel Color","Finish","Leather Color"].includes(key)});
          console.log(colour_name_key);
          if(colour_name_key.length <1)return;
          if(colour_name_key.length == 3){
            colour_name_key = colour_name_key[2];
          }else if(colour_name_key.length == 2){
            colour_name_key = colour_name_key[1];
          }else{
            colour_name_key = colour_name_key[0];
          }
          let colour_name = value["shopify_variants"][0]["options"][`${colour_name_key}`];
          
          colour_name = colour_name.trim(" ");
          console.log("s:colour_name:"+colour_name);
          if (colours.includes(colour_name)) return;
          colours.push(colour_name);
          console.log(colours);
          let color_value = variant_color_config[colour_name];
          if(!color_value)return;
          console.log(colour_name + " " + color_value);
          if (color_value && color_value.indexOf("cdn.shopify") != -1) {
            html += `<span class="color_items"><span id="${value["product_id"]}_color_1" data-id="${value["product_id"]}" data-source_id="${item["id"]}" data-img="${value['image_link']}"  data-color_value="${color_value}" data-sku="${value['shopify_variants'][0]['sku']}" style="background: url(${color_value}); background-size: cover;background-repeat:no-repeat;background-position:center;" onclick="selectColour(this)"></span></span>`;
          } else {
            html += `<span class="color_items"><span id="${value["product_id"]}_color_1" data-id="${value["product_id"]}" data-source_id="${item["id"]}" data-img="${value['image_link']}"  data-color_value="${color_value}" data-sku="${value['shopify_variants'][0]['sku']}" style="background: ${color_value};" onclick="selectColour(this)"></span></span>`;
          }
        });
      
       try{
         if (colours.length <= 1) {
          document.querySelector("div[data-id='" + item["id"] + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="none";
          return;
        }
         console.log("color_set:"+item["id"]);
        document.querySelector("div[data-id='" + item["id"] + "']").closest(".card-information").querySelector(".product_tile_color_holder").innerHTML = html;
         document.querySelector("div[data-id='" + item["id"] + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="block";
       }catch(e){
         console.log(e);
       }
   });
  });
}

function selectColour(_this){
  console.log("select:"+_this.getAttribute("data-img")+" sku:"+_this.getAttribute("data-sku"));
  let id= _this.getAttribute("data-source_id");
  console.log("id:"+id);
  document.querySelector("div[data-id='" + id + "']").closest(".card--media").querySelector("img").setAttribute("srcset",_this.getAttribute("data-img"));
  document.querySelector("div[data-id='" + id + "']").closest(".card--media").querySelector("img").setAttribute("src",_this.getAttribute("data-img"));

  document.querySelector("div[data-id='" + id + "']").closest(".card-information").querySelector("a").setAttribute("href",`/products/${_this.getAttribute("data-sku")}`);
  location.href=`/products/${_this.getAttribute("data-sku")}`;
}
